import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'src/store/features/auth/axiosCSRF';
import { getDjangoEndpoint } from 'src/utils/apiEndpoints';

// 로그아웃 정의 (값을 받아오기 위해)
export interface iLogoutState {
    isLoading: boolean;
    response : any
}

const initialState: iLogoutState = {
    isLoading: false,
    response : []
}

// 로그아웃 API Post
export const postLogoutAPI = createAsyncThunk(
    "POST_LOGOUT",
    async (_, { rejectWithValue, getState }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/logout/'

            const response = await axiosInstance.post(
                `${djangoEndpoint}${pathParam}`,
                {
                    withCredentials: true,
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data

        } catch (e) {
            console.error('로그아웃 에러 ')
            return rejectWithValue(e.response ? e.response.data : e.message)
        }
    }
);

const logoutSlice = createSlice({
    name: "logout",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postLogoutAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(postLogoutAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postLogoutAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            });
    }
});

export default logoutSlice.reducer;